/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyVendor } from '../models/SurveyVendor';
import type { SurveyVendorRequest } from '../models/SurveyVendorRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminSurveyVendorService {

    /**
     * get list of survey vendors
     * @returns any Success
     * @throws ApiError
     */
    public static listAdminSurveyVendors({
        limit,
        offset,
        search,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Search by name or code
         */
        search?: string,
    }): CancelablePromise<{
        rows?: Array<SurveyVendor>;
        count?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/surveyVendor',
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create SurveyVendor
     * @returns SurveyVendor Success
     * @throws ApiError
     */
    public static createSurveyVendor({
        requestBody,
    }: {
        requestBody: SurveyVendorRequest,
    }): CancelablePromise<SurveyVendor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyVendor',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Survey Vendor Information
     * @returns SurveyVendor Success
     * @throws ApiError
     */
    public static updateSurveyVendor({
        id,
        requestBody,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
        requestBody: SurveyVendorRequest,
    }): CancelablePromise<SurveyVendor> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/surveyVendor/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Vendor
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyVendor({
        id,
    }: {
        /**
         * Survey Vendor ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/surveyVendor/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * upload image
     * @returns any Success
     * @throws ApiError
     */
    public static uploadSurveyVendor({
        formData,
    }: {
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<{
        key?: string | null;
        url?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/surveyVendor/image',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
